<template>
    <div>
        <v-layout wrap justify-center align-center z-index="1">
            <v-flex md7 sm7 xs12>
                <dialogos-app :dialogos="dialogos" tucan="0" @update:currentText="currentText = $event"></dialogos-app>
            </v-flex>
        </v-layout>
        <v-layout wrap row justify-center align-center text-xs-center class="cont_page" z-index="1">
            <v-flex xs12 md5 class="cont-button">
              <button class="button-unidad hvr hvr-scale" @click="goToModulo()">
                <div class="cont-icono animated flipInY dura-1">
                  <img :src="require('@/assets/presentacion/unidad-'+unidadNumber+'.png')" alt="">
                </div>
                <div class="cont-name animated fadeInUp dura-1" :style="{'background':btnColors[unidadNumber-1]}">
                  <h3 class="t-first" :class="{'text-white':unidadNumber == 4}">Unidade {{this.unidadNumber}}</h3>
                </div>
              </button>
            </v-flex>
        </v-layout>
        <div class="cont-fondo">
          <svgslide20></svgslide20>
        </div>
    </div>
</template>
<script>
import nextConditions from "../../js/mixins/nextConditions";
import svgslide20 from '@/pages/unidad1/slide-mod20/svgslide20';
export default {
  mixins: [nextConditions],
  components: {
      svgslide20,
  },
  data() {
    return {
      dialogos: [
        'Acabamos a Unidade 1. Parabéns!',
        'Agora, comece a unidade 2.'
      ],
      currentText:0,
      btnColors:['#65B8FF','#2199FF','#0077DC','#005297'],
      iconActive: [true,false,false,false],
      unidadNumber: 2,
    }
  }
}
</script>
<style lang="scss" scoped>
// NOT SCOPED !!
@import '../../sass/globals';
.cont-fondo{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 80vh;
  z-index: 0;  
}
.mt-10{
  margin-top: 10vh;
}
.button-unidad{
  text-align: center;
  margin: 0 auto;
  margin-bottom: 10px;
  div{
    display: flex;
    justify-content: center;
    align-content: center;
    text-align: center;
  }
  .cont-icono{
    width: 150px;
    border-radius: 50%;
    margin: 0 auto;
    overflow: hidden;
    img{
       width: 150px;
    }
  }
  .cont-name{
    padding: 10px 35px;
    border-radius: 24px;
  }
}
.t-first{
   font-family:Poppins-Bold;
   font-size: 30px;
   margin: 0;
   padding: 0;
}
.text-white{
  color: #FFF;
}
</style>
